import { Route, Routes } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import React, { Suspense, lazy } from 'react'
import { snackbarActions } from '../Reducers/snackbarSlice'
import CircleLoading from '../Lib/Loading/CircleLoading'
import ReactGA from 'react-ga4'

const Login = lazy(() => import('../pages/Login/Login'))
const Register = lazy(() => import('../pages/Register/Register'))
// const GetStarted = lazy(() => import('../pages/GetStarted/GetStarted'))
const ResetPassword = lazy(() => import('../pages/ResetPassword/ResetPassword'))
const SendResetPasswordLink = lazy(() => import('../pages/ResetPassword/SendResetPasswordLink'))
const SetupCorporation = lazy(() => import('../pages/SetupCorporation/SetupCorporation'))
const PageNotFound = lazy(() => import('../pages/Errors/PageNotFound'))
const ChooseProduct = lazy(() => import('../pages/ChooseProduct/ChooseProduct'))
const CreateJoinEntity = lazy(() => import('../pages/CreateJoinEntity/CreateJoinEntity'))
const Status200 = lazy(() => import('../pages/Status/200'))
const Logout = lazy(() => import('../pages/Logout/Logout'))
const AliaSnackbar = lazy(() => import('../Lib/Snackbar/AliaSnackbar'))
const FirstStep = lazy(() => import('../pages/FirstStep/FirstStep'))

const AppSnackbar = () => {
	const dispatch = useDispatch()
	const snackbarReducer = useSelector((state) => state.snackbar)

	return (
		<AliaSnackbar
			isOpen={snackbarReducer?.isOpen}
			message={snackbarReducer?.message}
			duration={snackbarReducer?.duration}
			width={snackbarReducer?.width}
			type={snackbarReducer?.type}
			onClose={() => dispatch(snackbarActions.closeSnackbar())}
		/>
	)
}

function App() {
	const [isConnected, setIsConnected] = React.useState(false)
	const user = useSelector(x => x.auth)
	ReactGA.initialize('G-Y4ZN0TXW2M')

	React.useEffect(() => {
		if (user.token !== undefined && user.token !== null)
			setIsConnected(true)
		else
			setIsConnected(false)
	}, [user.token])

	return (
		<Suspense fallback={<CircleLoading />}>
			<AppSnackbar />
			<Routes>
				<Route path='/' element={isConnected ? <ChooseProduct /> : <Login />} />
				<Route path='/first-step' element={<FirstStep />} />
				<Route path='/status' element={<Status200 />} />
				<Route path='/login' element={<Login />} />
				<Route path='/log-out' element={isConnected ? <Logout /> : <Login />} />
				<Route path='/register' element={<Register />} />
				<Route path='/forgot-password' element={<SendResetPasswordLink />} />
				<Route path='/reset-password' element={<ResetPassword />} />
				<Route path='/onboarding/:entityID' element={<SetupCorporation />} />
				<Route path='/choose-product' element={isConnected ? <ChooseProduct /> : <Login />} />
				<Route path='/create-join-entity' element={isConnected ? <CreateJoinEntity /> : <Login />} />
				<Route path='*' element={<PageNotFound />} />
			</Routes>
		</ Suspense>
	)
}

export default App
